import { createSidecarMedium } from 'use-sidecar';
export var effectCar = createSidecarMedium();



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-remove-scroll/dist/es2015/medium.js
// module id = 178
// module chunks = 0